"use strict";

angular.module("vendor")
.service("ProductService", function($resource, $http, FlashBag, appConfig, gettextCatalog, PRODUCT_TYPES) {
    this.INVENTORY_QUANTITY_MAX = 4000000000;
    this.PROCUT_QUANTITY_MAX = 999999999;

    var productEditService = $resource(appConfig.API_SERVER + "/catalog/vendor/products/:id/", {
        id: "@id"
    }, {
        get: {
            method: "GET",
            isArray: false,
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        },
        save: {
            method: "POST",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        },
        update: {
            method: "PUT",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        }
        ,
        delete: {
            method: "DELETE",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        }
    });
    var productDepositsAutoComplete = $resource(appConfig.API_SERVER + "/catalog/vendor/products/deposits/auto-complete/", {}, {
        query: {
            method: "GET",
            isArray: false,
            ignoreLoadingBar: true
        }
    });

    this.query = function(params) {
        return productEditService.get(params);
    };

    this.get = function(id) {
        return productEditService.get({id: id});
    };

    this.delete = function(id) {
        return productEditService.delete({id: id}).$promise;
    };

    this.create = function(data) {
        return $http({
            url: appConfig.API_SERVER + "/catalog/vendor/products/",
            method: "POST",
            headers: {"Content-Type": undefined},
            data: data
        });
    };

    this.update = function(productId, data) {
        return $http({
            url: appConfig.API_SERVER + "/catalog/vendor/products/" + productId + "/",
            method: "PUT",
            headers: {"Content-Type": undefined},
            data: data
        });
    };

    this.importProducts = function(data) {
        return $http.post(appConfig.API_SERVER + "/import/products/", data, {
            transformRequest: angular.identity,
            headers: {"Content-Type": undefined}
        });
    };

    this.importProductImage = function(data) {
        return $http.post(appConfig.API_SERVER + "/catalog/vendor/products/images/", data, {
            transformRequest: angular.identity,
            headers: {"Content-Type": undefined}
        });
    };

    this.importProductVariantImage = function(data) {
        return $http.post(appConfig.API_SERVER + "/catalog/vendor/products/variants/images/", data, {
            transformRequest: angular.identity,
            headers: {"Content-Type": undefined}
        });
    };

    this.importProductAttachment = function(data) {
        return $http.post(appConfig.API_SERVER + "/catalog/vendor/products/attachments/", data, {
            transformRequest: angular.identity,
            headers: {"Content-Type": undefined}
        });
    };

    this.deleteProductAttachment = function(id) {
        return $http.delete(appConfig.API_SERVER + "/catalog/vendor/products/attachments/" + id + "/");
    };

    this.getProductTypes = function() {
        var productTypes = {};
        productTypes[PRODUCT_TYPES.STANDARD] = gettextCatalog.getString("Product Standard")
        productTypes[PRODUCT_TYPES.DEPOSIT] = gettextCatalog.getString("Product Deposit")
        productTypes[PRODUCT_TYPES.DISTRIBUTION] = gettextCatalog.getString("Product Distribution")
        return productTypes;
    };

    this.queryProductDeposits = function(search) {
        return productDepositsAutoComplete.query({
                search: search,
                page: 1,
            },
            function onSuccess(data) {
            },
            function onError(response) {
                FlashBag.apiError(response);
            }
        );
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/product/product.service.js
// module id = 872
// module chunks = 0